import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetPaycardStatisticsRequestSchema,
  TGetPaycardStatisticsResponseSchema,
} from "./getPaycardStatistics.schema";

export const getPaycardStatistics = (axios: IAxiosInstance) => {
  return async (params: TGetPaycardStatisticsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetPaycardStatisticsResponseSchema>
    >(`/api/paycards/statistics`, { params });

    return response.data;
  };
};
